import { number, object } from 'yup'

export const formFieldGroups = {
  living: {
    food: 'Food',
    entertainment: 'Entertainment',
    rent: 'Rent (NOT Mortgage Payment)',
    power: 'Power',
    heating: 'Heating Costs',
    water: 'Water/Sewer',
    homeInsurance: 'Home Insurance',
    homePhone: 'Home Telephone',
    cellPhone: 'Cellular Telephone',
    propertyTax: 'Property Taxes',
    homeRepairs: 'Home Repairs/Improvements',
    condoFees: 'Condo Fees',
  },
  transportation: {
    gas: 'Gas/Fuel',
    carInsurance: 'Car Insurance',
    repairs: 'Repairs',
    carPayment: 'Car Payment',
    parking: 'Parking',
    publicTransportation: 'Public Transportation',
    tires: 'Tires',
  },
  debtPayment: {
    loans: 'Loans',
    creditLines: 'Credit Lines',
    mortgagePayment: 'Mortgage Payment',
    creditCardPayment: 'Credit Card Payment',
    otherDebtPayment: 'Other',
  },
  commitedSavings: {
    rrsp: 'RRSP',
    tfsa: 'TFSA',
    resp: 'RESP',
    nonRegistered: 'Non-Registered',
    employeeSavingsPlan: 'Employer Savings Plans',
  },
  dailyLivingExpenses: {
    groceries: 'Groceries',
    childCare: 'Child Care',
    dryCleaning: 'Dry Cleaning',
    dinningOut: 'Dining Out',
    houseCleaning: 'House Cleaning',
    petExpenses: 'Pet Expenses',
  },
  personalRelatedExpenses: {
    clothing: 'Clothing',
    gifts: 'Gifts',
    salon: 'Salon/Barber',
    books: 'Books/Music',
    miscSpending: 'Misc. Spending',
    dependant: 'Dependant/Home Care',
  },
  entertainment: {
    cable: 'Cable',
    movies: 'Movies/Concerts/Shows',
    alcohol: 'Alcohol/Tobacco',
  },
  recreational: {
    membership: 'Membership/User Fees',
    sportsEquipment: 'Sports Equipment',
    teamDues: 'Team Dues',
    childActivities: `Chidren's Activities`,
  },
  duesSubscriptions: {
    magazines: 'Magazines',
    newspaper: 'Newspapers',
    internet: 'Internet',
    charity: 'Charity',
    bankFees: 'Banking Fees',
    creditCardFees: 'VISA Fees',
  },
  healthExpenses: {
    healthClubDues: 'Health Club Dues',
    medicalInsurance: 'Medical Insurance',
    prescriptions: 'Prescriptions',
    dentalExpenses: 'Dental Expenses',
    otcDrugs: 'Over-the-Counter Drugs',
    coPays: 'Co-Pays',
    veterinarian: 'Veterinarian',
    lifeInsurance: 'Life Insurance',
    disabilityInsurance: 'Disability Insurance',
    criticalIllnessInsurance: 'Critical Illness Insurance',
    longTermCareInsurance: 'Long-term Care Insurance',
  },
  vacationExpenses: {
    airFare: 'Air Fare',
    accommodations: 'Accommodations',
    vacationFood: 'Food',
    travelInsurance: 'Travel Insurance',
    petBoarding: 'Pet Boarding',
    rentalCar: 'Rental Car',
    cottageExpenses: 'Cottage Expenses',
  },
  otherExpenses: {
    cppPremiums: 'CPP Premiums',
    eiPremiums: 'EI Premiums',
    otherPayDeductions: 'Other Payroll Deduction',
    charityDonations: 'Charitable Donations',
    privateSchoolTuition: 'Private School Tuition',
    otherMiscellaneous: 'Miscellaneous',
  },
}

export const initialValues = {
  monthlyIncome: '',
}
const validationFields = {
  monthlyIncome: number()
    .transform((cv, ov) => (ov === '' ? undefined : cv))
    .typeError('must be a number'),
}

// https://github.com/jquense/yup/issues/66#issuecomment-318486137
Object.entries(formFieldGroups).forEach(([groupId, group]) => {
  Object.keys(group).forEach(fieldId => {
    const key = `${groupId}-${fieldId}`
    initialValues[key] = ''
    validationFields[key] = number()
      .transform((cv, ov) => (ov === '' ? undefined : cv))
      .typeError('must be a number')
  })
})

export const formSchema = object(validationFields)
